import { Seo, breadcrumbLd } from "@/site/seo";
import { SECURITY, SITE } from "@/site/content";
import { Heading } from "@/site/components/Section";

export default function SecurityPage() {
  return (
    <>
      <Seo title="Security" description="How Postern isolates tenants, enforces roles and signing authority, encrypts credentials, backs up data, and where we are on SOC 2. Written for the person who has to approve us." jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Security", path: "/security" }])]} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 900 }}>
          <Heading eyebrow="Security" title="How we keep your order forms, prices and customers separate from everyone else's." lede={SECURITY.intro} />
          <div className="prose">
            {SECURITY.sections.map((s) => (
              <div key={s.h}><h2>{s.h}</h2><ul>{s.items.map((i) => <li key={i}>{i}</li>)}</ul></div>
            ))}
            <h2>Responsible disclosure</h2>
            <p>{SECURITY.disclosure} Our <a href="/.well-known/security.txt">security.txt</a> is published.</p>
            <h2>Sub-processors</h2>
            <p>Hosting provider (your region on request), transactional email provider, and — only if you enable them — Stripe (checkout on signing links) and Anthropic (on your own key). Full list and DPA on request{SITE.securityEmail ? <> at <a href={`mailto:${SITE.securityEmail}`}>{SITE.securityEmail}</a></> : <> via the <a href="/contact">contact form</a></>}.</p>
          </div>
        </div>
      </section>
    </>
  );
}
